import React from 'react';

const ContactUs = () => {
  return (
    <div>
      <h1>Contact Us</h1>
      <p>Contact us page content goes here.</p>
    </div>
  );
};

export default ContactUs;